import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICommonState } from "./common.types";
import { defaultCommonState } from "./common.state";
import { fetchEndpointsAsync, fetchModuleAsync } from "./common.actions";
import { produce } from "immer";
import { LoadState } from "../../constants/enum";



const commonSlice = createSlice({
    initialState: defaultCommonState,
    name: "common",
    reducers: {
        displayErrorDialog: (state, action: PayloadAction<ICommonState["errorVisible"]>) => {
            state.errorVisible = action.payload
        },
        closeErrorDialog: (state) => {
            state.errorVisible = null
        },
        displaySnackBarDialog: (state, action: PayloadAction<ICommonState["snackbarVisible"]>) => {
            state.snackbarVisible = action.payload
        },
        closeSnackBarDialog: (state) => {
            state.snackbarVisible = null
        },
        openLoaderWithMessage: (state, action: PayloadAction<ICommonState["loader_with_message"]["message"]>) => {
            state.loader_with_message.loading = true
            state.loader_with_message.message = action.payload
        },
        closeLoaderWithMessage: (state) => {
            state.loader_with_message.loading = false
            state.loader_with_message.message = defaultCommonState["loader_with_message"]["message"]
        },
        clearEndpoints: (state) => {
            state.endPointsByModule = defaultCommonState["endPointsByModule"]
        },
    },
    extraReducers: (builder) => {
        //#################################### fetchModuleAsync ##############################################
        builder.addCase(fetchModuleAsync.pending, (state, action) => {
            console.log("action.meta.arg pending", action.meta.arg)
            const isView = action.meta.arg === "VIEW";

            const newState = produce(state, (draftState) => {
                if (isView) {
                    draftState.modules.tableViews.loading = LoadState.pending;
                } else {
                    draftState.modules.tableNames.loading = LoadState.pending;
                }
            });
            return newState
        });

        builder.addCase(fetchModuleAsync.fulfilled, (state, action) => {
            const { isView, data } = action.payload;
            const newState = produce(state, (draftState) => {
                if (isView) {
                    draftState.modules.tableViews = { data, loading: LoadState.succeeded };
                } else {
                    draftState.modules.tableNames = { data, loading: LoadState.succeeded };
                }
            });
            return newState
        });

        builder.addCase(fetchModuleAsync.rejected, (state, action) => {
            // Handle rejected case properly
            const payload = action.payload as { isView: boolean; data: string[] } | undefined;
            const isView = payload?.isView ?? action.meta.arg === "VIEW";

            const newState = produce(state, (draftState) => {
                if (isView) {
                    draftState.modules.tableViews.loading = LoadState.failed;
                } else {
                    draftState.modules.tableNames.loading = LoadState.failed;
                }
            });
            return newState
        });




        //#################################### fetchEndpointsAsync ##############################################
        builder.addCase(fetchEndpointsAsync.pending, (state, action) => {
            state.endPointsByModule.loading = LoadState.pending;
        });

        builder.addCase(fetchEndpointsAsync.fulfilled, (state, action) => {
            state.endPointsByModule.loading = LoadState.succeeded;
            state.endPointsByModule.data = action.payload;
        });

        builder.addCase(fetchEndpointsAsync.rejected, (state, action) => {
            state.endPointsByModule.loading = LoadState.succeeded;
            state.endPointsByModule.data = {};
        });

    }
})

export const commonReducer = commonSlice.reducer;
export const {
    displayErrorDialog,
    closeErrorDialog,
    displaySnackBarDialog,
    closeSnackBarDialog,
    openLoaderWithMessage,
    closeLoaderWithMessage,
    clearEndpoints
} = commonSlice.actions;